function init() {
  let dateAttribute = document.querySelectorAll('[data-calendar-icon-hide="true"]');

  if (dateAttribute) {
    for (const item of dateAttribute) {
      item.parentElement.classList.add('kirinus-hide-icon');
    }
  }
}

export default {
  init,
};
